module.exports = __webpack_public_path__ + "img/d5.a3c693e5.png";